import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';

const InquiryFilterDrawer = ({
	visible,
	setVisible,
	title,
	setTitle,
	message,
	setMessage,
	senderName,
	setSenderName,
	senderEmail,
	setSenderEmail,
	senderMobile,
	setSenderMobile,
	recieverParty,
	setRecieverParty,
	recieverName,
	setRecieverName,
	fromDate,
	setFromDate,
	toDate,
	setToDate,
	handleSubmit,
	resetFunction,
	loading,
}) => {
	const onSearchClick = (e) => {
		handleSubmit(e);
		setVisible(false);
	};

	const onResetClick = () => {
		resetFunction();
		setVisible(false);
	};

	return (
		<Sidebar
			visible={visible}
			position="right"
			onHide={() => setVisible(false)}
			style={{ width: '28rem', maxWidth: '90vw' }}
			header="Filters"
		>
			<form
				onSubmit={(e) => {
					e.preventDefault();
					onSearchClick(e);
				}}
				className="d-flex flex-column justify-content-between h-100 gap-1"
			>
				<div>
					<div className="field">
						<label htmlFor="title">Title</label>
						<InputText
							id="title"
							value={title}
							onChange={(e) => setTitle(e.target.value)}
							placeholder="Enter title"
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="message">Message</label>
						<InputText
							id="message"
							value={message}
							onChange={(e) => setMessage(e.target.value)}
							placeholder="Enter message"
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="sender_name">Sender name</label>
						<InputText
							id="sender_name"
							value={senderName}
							onChange={(e) => setSenderName(e.target.value)}
							placeholder="Enter sender name"
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="sender_email">Sender email</label>
						<InputText
							id="sender_email"
							value={senderEmail}
							onChange={(e) => setSenderEmail(e.target.value)}
							placeholder="Enter sender email"
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="sender_mobile">Sender mobile number</label>
						<InputText
							id="sender_mobile"
							value={senderMobile}
							onChange={(e) => setSenderMobile(e.target.value)}
							placeholder="Enter sender mobile"
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="party">Receiver Party id</label>
						<InputText
							id="party"
							value={recieverParty}
							onChange={(e) => setRecieverParty(e.target.value)}
							placeholder="Enter Receiver Party id"
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="reciever_name">Receiver name</label>
						<InputText
							id="reciever_name"
							value={recieverName}
							onChange={(e) => setRecieverName(e.target.value)}
							placeholder="Enter Receiver Name"
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="from_date">From date</label>
						<Calendar
							id="from_date"
							placeholder="From Date"
							value={fromDate}
							onChange={(e) => setFromDate(e.value)}
							readOnlyInput
							className="w-100"
						/>
					</div>

					<div className="field">
						<label htmlFor="to_date">To date</label>
						<Calendar
							id="to_date"
							placeholder="To Date"
							value={toDate}
							onChange={(e) => setToDate(e.value)}
							readOnlyInput
							className="w-100"
						/>
					</div>
				</div>

				<div className="d-flex gap-2 justify-content-between mt-2 pt-3 border-top prime-react-btn">
					<button
						type="button"
						className="btn btn-outline-secondary w-100"
						disabled={loading}
						onClick={onResetClick}
					>
						Reset
					</button>
					<button
						type="submit"
						className="btn submit-btn text-white w-100"
						disabled={loading}
					>
						Search
					</button>
				</div>
			</form>
		</Sidebar>
	);
};

export default InquiryFilterDrawer;

